import { NgFor, NgIf, NgClass } from '@angular/common';
import { Component } from '@angular/core';
import {
  expandOnEnterAnimation,
  collapseOnLeaveAnimation,
} from 'angular-animations';
import { aiPoweredEducationalV2 } from '../../../shared/models/ai-powered-educational.model';
import { IconsModule } from '../../icons/icons.module';


@Component({
  selector: 'why-atomo',
  standalone: true,
  imports: [IconsModule, NgFor, NgIf, NgClass],
  templateUrl: './why-atomo.component.html',
  styleUrl: './why-atomo.component.scss',
  animations: [
    expandOnEnterAnimation({ duration: 400 }),
    collapseOnLeaveAnimation({ duration: 400 }),
  ],
})
export class WhyAtomoComponent {
  aiEductionalContentCards: aiPoweredEducationalV2[] = [
    {
      title: ' Individualized AI',
      description:
        'Understands how each student learns and supports them accordingly',
      isExpanded: false,
    },
    {
      title: ' Math & Physics Solver',
      description:
        'Step-by-step support for tough concepts',
      isExpanded: false,
    },
    {
      title: ' Vocabulary Builder',
      description:
        'For students learning in English or regional languages',
      isExpanded: false,
    },
    {
      title: ' Pack My Bag',
      description:
        'Daily reminders for what to carry based on schedule',
      isExpanded: false,
    },
    {
      title: 'Smart Admin Shield',
      description:
        'One dashboard to manage everything',
      isExpanded: false,
    },
    {
      title: 'Works Offline Too',
      description:
        'Designed for Indian classrooms with limited tech',
      isExpanded: false,
    },
  ];

  onCardClick(index: number) {
    this.aiEductionalContentCards.forEach((a, i) => {
      if (i != index) {
        a.isExpanded = false;
      }
    });
    this.aiEductionalContentCards[index].isExpanded =
      !this.aiEductionalContentCards[index].isExpanded;
  }
}
